<template>
  <pt-award-audit-table class="pt-award-audit-table__withData" @getTableData="getTableData" :tableLabels="tableLabels" :totalNumber="totalNumber"
  :tableData="tableData" ref="table" @select="select" @selectAll="selectAll" :isOutside="isOutside" :isShowSelect="isShowSelect" v-loading="loading"
  :customerStatisticsData="customerStatisticsData">
  <slot/>
  </pt-award-audit-table>
</template>

<script>
import PtAwardAuditTable from './index'
export default {
  name: 'pt-award-audit-table__withData',
  components: {
    'pt-award-audit-table': PtAwardAuditTable
  },
  props: {
    listSort: {
      type: String,
      default: null
    },
    isShowSelect: {// 表格是否显示选框
      type: Boolean,
      default: false
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    businessType: {
      type: String
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    },
    businessType () {
      this.resetPage()
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      isOutside: false,
      totalNumber: 0,
      loading: false,
      customerStatisticsData: {}
    }
  },
  methods: {
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    select (selection, row) {
      this.$emit('select', selection, row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      let data = {
        ...this.paramsData,
        businessType: this.businessType || 'CUSTOMER_BRING_NEW_QJK',
        pageable: {
          page: this.page,
          size: size || this.pageSize,
          sort: this.listSort + ',desc'
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('bringNewRewardListStatistics', data).then(res => {
        this.tableData = res.data.list
        this.totalNumber = res.totalNumber
        let { allCustomerOfMoney, newCustomerOfMoney, oldCustomerOfMoney } = res.data
        this.customerStatisticsData = { allCustomerOfMoney, newCustomerOfMoney, oldCustomerOfMoney }
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取奖励记录失败')
      })
    }
  }
}
</script>
